<template>
  <div v-if="!isActive" class="wrapper">
    <div class="scroll-wrapper">
      <section> 
        <div class="header">
          <div class="logo-text">
            <span class="logo-dark">My</span><span class="logo-orange">VPS</span>
          </div>
        </div>
      </section>
      <section class="snap-section intro-section">
        <IntroSection />
      </section>
      <section class="features-section">
        <Features />
      </section>
      <section class="servers-section">
        <Servers />
      </section>
      <section class="faq-section">
        <FAQ />
      </section>
    </div>
  </div>
  <SubscriptionButton v-if="!isActive" :handleClick="handleClick" />
  <ActiveView v-else />

 <transition name="slide-up">
    <LoaderModal
    v-if="showLoaderModal && paymentData"
    :isVisible="true"
    :type="'cloud'"
    :amount="paymentData.amount"
    :currency="paymentData.currency"
    :description="paymentData.description"
    :publicId="paymentData.publicTerminalId"
    :orderId="paymentData.metadata.order_id"
    :paymentSchema="paymentData.paymentSchema"
    :uid="userInfo?.user_id || 0"
    @close="showLoaderModal = false"
    @paid-success="onPaidSuccess"
  />
  </transition>
</template>

<script>
import { getAuthToken, getUserInfo } from "./auth";
import { ref, computed } from 'vue'

import LoaderModal from "@/components/android/modal/LoaderModal.vue";
import ActiveView from "@/components/android/ActiveView.vue";

import SubscriptionButton from "@/components/android/components/SubscribeButton.vue";
import IntroSection from "@/components/android/components/IntroComponent.vue"
import Features from "@/components/android/components/FeaturesComponent.vue";
import Servers from "@/components/android/components/ServersComponent.vue"
import FAQ from "@/components/android/components/FAQComponent.vue"
import { getPlayStoreUrl } from '@/utils/playStoreUrl.js'
import { trackGooglePlayGoal } from '@/utils/trackGooglePlayGoal.js'


export default {
  name: 'MainComponent',
  components: {
    LoaderModal,
    ActiveView,
    SubscriptionButton,
    Features,
    IntroSection,
    Servers,
    FAQ
  },
  setup() {
    const isAndroid = ref(false)
    const paymentData = ref(null)
    const platform = ref('')
    const paymentUrl = ref('')
    const showLoaderModal = ref(false)
    const userInfo = ref(null)

    const isActive = computed(() => {
      return userInfo.value?.subscriptionEnd && userInfo.value.subscriptionEnd > Date.now()
    })
 
    const onPaidSuccess = async () => {
    console.log('✅ Оплата подтверждена — обновляем userInfo')

    showLoaderModal.value = false

    const infoRes = await getUserInfo()
    if (infoRes.success) {
      userInfo.value = infoRes.userInfo
      localStorage.setItem('cachedUserInfo', JSON.stringify(infoRes.userInfo))
    } else {
    }
}

    const handleClick = () => {
      trackGooglePlayGoal()
      const url = getPlayStoreUrl()
      window.open(url, url.startsWith('http') ? '_blank' : '_self')
    }

    const init = async () => {
  platform.value = /Android/i.test(navigator.userAgent) ? 'android' : 'other'

  const cached = localStorage.getItem('cachedUserInfo')
  if (cached) {
    try {
      userInfo.value = JSON.parse(cached)
    } catch (e) {
      console.warn('Ошибка при парсинге кэша userInfo:', e)
    }
  }

  try {
    const token = await getAuthToken()
    const infoRes = await getUserInfo()
    if (infoRes.success) {
      userInfo.value = infoRes.userInfo
      localStorage.setItem('cachedUserInfo', JSON.stringify(infoRes.userInfo))
    } else {
      console.warn('Ошибка при получении userInfo:', infoRes.error)
    }
  } catch (err) {
    console.warn('Ошибка при загрузке данных пользователя:', err)
  }
}
     init()

   return {
      platform,
      handleClick,
      showLoaderModal,
      paymentUrl,
      isActive,
      onPaidSuccess,
      paymentData,
      userInfo
    }
  }
}
</script>

<style>
:root {
  --header-h: 90px;
  --footer-h: 88px;
}
.section-title {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}
</style>

<style scoped>
.header {
      width: 100%;
      background: #fff;
      display: flex;
      align-items: center; 
      justify-content: center;
      padding: 12px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.1);
    }
    .logo-text {
      font-family: 'Play', sans-serif;
      font-size: 44px;
      font-weight: 700;
    }
    .logo-text .logo-dark { color: #1C0000; }
    .logo-text .logo-orange { color: #FAA820; }

.wrapper {
  display: flex;
  flex-direction: column;
  background: #bbd5df url('@/assets/images/android/rocketAndroid.png') no-repeat bottom center;
  background-size: 100% auto;
  scroll-snap-align: start;
  height: 100vh;
  position: relative;
}

.scroll-wrapper {
  flex: 1;
  overflow-y: auto;
  scroll-padding-bottom: var(--footer-h);
}

.intro-section {
  position: sticky;
  height: 100%;
  padding: 16px;
  flex-shrink: 0;
}

@media (max-width: 1023.99px) {
    section {
        margin-bottom: 0;
    }
}

section {
    margin-bottom: 0;
}

</style>
